import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import { LectureDetails } from '../../../../../api/types/lecturers/details/lecture-details';

export const loadLectureDetailsOperation = async (
  programId: number,
  courseId: number,
  lectureId: number,
  setData: (lectureDetails: LectureDetails) => void,
) => {
  try {
    const res = await appApi.getLectureDetails(programId, courseId, lectureId);
    const resData: LectureDetails = res.data.body;
    setData(resData);
    console.log(`\n\n ${JSON.stringify(resData)}`);
  } catch (e) {
    console.error();
    toast.error('משהו קרה, לא ניתן לטעון את פרטי המפגש...');
  }
};
